export default __webpack_public_path__ + "chrome.jpg";